const DEFAULT_REDIRECT_URI = "betterintentions://captcha-callback";
const DEFAULT_ACTION_NAME = "mobile_signup";

function readSearchParams(search = "") {
  return new URLSearchParams(String(search || ""));
}

// Appends callback metadata to the native redirect URL after Turnstile verification succeeds.
export function appendMobileCaptchaQueryParam(url, key, value) {
  const separator = String(url || "").includes("?") ? "&" : "?";
  return `${url}${separator}${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
}

// Resolves the mobile app redirect target from the current query string, with a safe fallback.
export function getMobileCaptchaRedirectUri(search = window.location.search) {
  const redirectUri = readSearchParams(search).get("redirect_uri") || DEFAULT_REDIRECT_URI;
  return redirectUri.trim();
}

// Resolves the Turnstile action name for the mobile flow from the current query string.
export function getMobileCaptchaActionName(search = window.location.search) {
  return (readSearchParams(search).get("action") || DEFAULT_ACTION_NAME).trim();
}
